import { render } from "./PublishedCollections.vue?vue&type=template&id=ed88162a"
import script from "./PublishedCollections.vue?vue&type=script&lang=js"
export * from "./PublishedCollections.vue?vue&type=script&lang=js"
script.render = render

export default script